import { createContainer } from 'unstated-next';
import { useState } from 'react';

const initialState = {
  members: [],
  teamBusinessId: null,
  isLoading: false,
  isUserDeleting: false,
};

const useTeamContainer = stateParams => {
  const combinedState = {
    ...initialState,
    ...stateParams,
  };
  const [state, updateState] = useState(combinedState);

  const resetTeamState = () => {
    updateState(initialState);
  };

  const setIsLoading = isLoading => {
    updateState(prev => ({
      ...prev,
      isLoading,
    }));
  };

  const setIsUserDeleting = isUserDeleting => {
    updateState(prev => ({
      ...prev,
      isUserDeleting,
    }));
  };

  const setMembers = (members, businessId) => {
    updateState(prev => ({
      ...prev,
      members,
      teamBusinessId: businessId,
    }));
  };

  const addNewMember = member => {
    updateState(prev => ({
      ...prev,
      members: [...prev.members, member],
    }));
  };

  const removeMember = id => {
    updateState(prev => ({
      ...prev,
      members: prev.members.filter(member => member.id !== id),
    }));
  };

  const updateMember = updatedMember => {
    updateState(prev => {
      return {
        ...prev,
        members: prev.members.map(member =>
          updatedMember.user.id === member.user.id ? updatedMember : member
        ),
      };
    });
  };

  const updateMemberPermissions = newPermissions => {
    updateState(prev => {
      const updatedMembers = prev.members.map(member => {
        return +newPermissions.userId === +member.id
          ? {
              ...member,
              permissions: {
                ...member.permissions,
                role: newPermissions.role,
                clientIds: newPermissions.clientIds,
              },
            }
          : member;
      });

      return {
        ...prev,
        members: updatedMembers,
      };
    });
  };

  return {
    state,
    setIsLoading,
    setMembers,
    addNewMember,
    removeMember,
    updateMember,
    updateMemberPermissions,
    resetTeamState,
    setIsUserDeleting,
  };
};

const TeamContainer = createContainer(useTeamContainer);

export default TeamContainer;
